// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BGfIX","toggle":"styles_toggle__oheYb","preview":"styles_preview__2H6AE"};